import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import { IChangeHR } from '../nest-model/access-management';
import { RequestNewForgotPasswordDto, ResponseUserAccessGroupDto, RequestNewCheckCodeDto, ResponseGetGroupAdminDto, ResponseGetListHRGoDto, RequestchangeHRDto } from '../gd-only/dto/access-managements.dto';
import { ResponseData } from '../nest-responses';
import { Observable } from "rxjs";

/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AccessManagementApiProvider {

  private module: string = 'accessmanagements';
  private model: string = 'accessmanagements';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello AccessManagementProvider Provider');
  }

  changeHR(formData: RequestchangeHRDto) {
    const method: string = "POST";
    const func: string = "changeHR";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, this.model, func, params, urlParams, this.module);
    return this.nestApi.request<IChangeHR>(method, url, params, urlParams, body, contentType);
  }

  newforgotPassword(payload: RequestNewForgotPasswordDto) {
    const method: string = "POST";
    const func: string = "newforgotPassword";
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, this.model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseData<boolean>>(method, url, params, urlParams, body, contentType);
  }

  public userAccessGroup(): Observable<ResponseData<ResponseUserAccessGroupDto>> {
    const method: string = 'GET';
    const func: string = 'userAccessGroup';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
    return this.nestApi.request<ResponseData<ResponseUserAccessGroupDto>>(method, url, params, urlParams, body, null, null, null, false);
  }

  newCheckCode(payload: RequestNewCheckCodeDto) {
    const method: string = "POST";
    const func: string = "newCheckCode";
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, this.model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseData<any>>(method, url, params, urlParams, body, contentType, null, true);
  }

  public getGroupAdmin() {
    const method: string = 'GET';
    const func: string = 'getGroupAdmin';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
    return this.nestApi.request<ResponseData<ResponseGetGroupAdminDto[]>>(method, url, params, urlParams, body, null, null, null, false);
  }

  public listHRGo(groupName = '') {
    const method: string = 'GET';
    const func: string = 'listHRGo';
    const params: any = {};
    const urlParams: any = { groupName };
    const body: any = {};

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
    return this.nestApi.request<ResponseData<ResponseGetListHRGoDto>>(method, url, params, urlParams, body, null, null, null, false);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/access-management/access-management-api.ts